import React from 'react';
import './zero-state-updates-card.scss';

interface ZeroStateProps {
    image: string;
    title: string;
    description: string;
}
export const ZeroState: React.FC<ZeroStateProps> = ({
    image,
    title,
    description,
}) => {
    const baseClassName = 'zeroState';
    return (
        <div className={`${baseClassName}`}>
            <div className={`${baseClassName}__wrapper`}>
                <img
                    className={`${baseClassName}__wrapper__image`}
                    src={image}
                    alt=""
                />
                <div className={`${baseClassName}__wrapper__description`}>
                    <h3>{title}</h3>
                    <h3>{description}</h3>
                </div>
            </div>
        </div>
    );
};
